import {PhoneHQButton, PhoneHQConfirmDialog} from 'ch3-ui-lib';
import {useState} from "react";
import {useNavigate} from 'react-router-dom';
import {useDeleteApiKeyMutation} from "../../../store/features/integrations/integrationsService";

interface DeleteApiKeyModalProps {
    id: number | string;
}

const DeleteApiKeyModal = ({id}: DeleteApiKeyModalProps) => {
    const [deleteApiKey, {isLoading}] = useDeleteApiKeyMutation();
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);

    const handleRemove = async () => {
        await deleteApiKey({id: Number(id)});
        setOpen(false);
        navigate("../admin/api/list");
    };

    return (
        <>
            <PhoneHQButton variant="text-danger" onClick={() => setOpen(true)} className="p-0" phq-id='apiList-deleteApiKeyTriggerBtn'>Delete</PhoneHQButton>
            <PhoneHQConfirmDialog
                open={open}
                onOpenChange={setOpen}
                title="Delete API key"
                cancelLabel="Cancel"
                confirmLabel="Yes, delete"
                tone="danger"
                busy={isLoading}
                onConfirm={handleRemove}
            >
                Are you sure you want to delete this API key?
            </PhoneHQConfirmDialog>
        </>
    );
};

export default DeleteApiKeyModal;
